import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuditTrialDetails } from '../../shared/models/audits/audit-trial-details';

@Component({
  selector: 'app-scope-audit-modal',
  templateUrl: './scope-audit-modal.component.html',
  styleUrls: ['./scope-audit-modal.component.scss']
})
export class ScopeAuditModalComponent {
  @Input() isShowScopeAuditModal: boolean = false;
  @Input() auditData: AuditTrialDetails[] = [];
  @Input() scopeName: string = '';
  @Output() closeModal = new EventEmitter<boolean>();

  closeScopeAuditModal() {
    this.isShowScopeAuditModal = false;
    this.closeModal.emit(false);
  }
}
